export function isXYObject(
  points: Highcharts.SeriesLineOptions["data"],
): points is { x: number; y: number | null }[] {
  return (
    !points?.[0] ||
    (typeof points[0] !== "number" && "x" in points[0] && !points.some(p => p === null))
  );
}

export function isYObject(
  points: Highcharts.SeriesLineOptions["data"],
): points is { y: number | null }[] {
  return (
    !points?.[0] ||
    (typeof points[0] !== "number" &&
      !("x" in points[0]) &&
      "y" in points[0] &&
      !points.some(p => p === null))
  );
}

export function isXYArray(
  points: Highcharts.SeriesLineOptions["data"],
): points is [number, number | null][] {
  return (
    !points?.[0] ||
    (Array.isArray(points[0]) && typeof points[0][0] === "number" && !points.some(p => p === null))
  );
}
